import * as React from 'react'
import axios, { CancelToken } from 'axios'
import wp from '../utils/wp'
import _ from 'lodash'
import store from '../redux/store';
import { logOut, loginSuccess, actionRefreshToken } from '../redux/actions/authActions';
import config from '../constants/config';
import { keyGenerator, withQuery } from '../utils';
import moment from "moment"
import * as actions from '../redux/actions'
import { getTimezoneOffset } from './utilsT';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

export const AxiosInstance = axios.create({
  baseURL: config.url.wpJson,
})



enum RequestmMethods {
  GET, POST, DELETE
}


/**
 * This is equivalent to:
 * type RequestmMethods = 'GET' | 'POST' | 'DELETE';
 */
type RequestmMethodsStrings = keyof typeof RequestmMethods;



const refreshTokenLogic = failedRequest => {
  let refreshToken = localStorage.getItem("refreshToken")
  const options = {
    method: "POST",
    headers: { 'Authorization': `Bearer ${refreshToken}` },
    data: {},
    url: `${config.url.wpJson}/wp/v2/token/refresh`,
  };
  return axios(options).then(res => {

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("refreshToken", res.data.refresh_token);

    // setTimeout(() => {
    //   let payload = {
    //     token: res.data.refresh_token,
    //     refreshToken: res.data.refresh_token,
    //     tokenExpires: res.data.exp,
    //   }
    //   store.dispatch(actionRefreshToken(payload))
    // }, 100);

    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + res.data.token;
    return Promise.resolve();
  }).catch((error) => {

    if (error.response) {
      const regex = /^\b(rest_authentication_)/g;
      if ((error.response.status == 403 || error.response.status == 401) && error.response.data.code && regex.test(error.response.data.code)) {
        //  console.log("error->response",error.response)
        /**
         * logout
         */
        store.dispatch(logOut(true))
      }
    }
    throw error
  })
};

/**
 * Instantiate the interceptor
 */
createAuthRefreshInterceptor(AxiosInstance, refreshTokenLogic);

// Add a request interceptor
AxiosInstance.interceptors.request.use(async (config) => {
  config['timeData'] = { startTime: new Date() }
  let token = localStorage.getItem("token")

  if (token && token != "" && !_.has(config, "headers.Authorization")) {
    config.headers = {
      ...config.headers, ...{
        'Authorization': `Bearer ${token}`
      }
    }
  }

  const methodReadAble = ['GET', 'get', 'DELETE', 'delete']
  if (methodReadAble.includes(config.method) && config.data && _.isObject(config.data)) {
    config.url = withQuery(config.url, config.data)
  }


  return config;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
});

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {

    if (_.has(error, "response.status") && error.response.status !== 401 && error.response.status != 403) {
      return Promise.reject(new Error(handleErrorResponse(error)));
    }
    return Promise.reject(error);
  }
);



/**
 * handelErrorReponse
 * @param error
 */
const handleErrorResponse = (error) => {
  console.log("error.response", error.response)
  if (error.response) {
    if (error?.response?.data?.message) {
      const regex = /^[[][jwt_auth]+[\]]/g;
      if (regex.test(error.response.data.code)) {
        return restMessageError(error.response.data.message)
      }
    }
    if (error.response.data && error.response.data.message) {
      return restMessageError(error.response.data.message)
    }

    if (error.response.status == 403) {

      return error;
    }

  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js

    return "The request was made but no response was received"

  } else {
    // Something happened in setting up the request that triggered an Error
    return error.message
  }
}

/**
 * remove <Tags></Tangs>
 * @param message
 */
const restMessageError = (message: string = ""): string => {
  const regexRemoveTags = /(<([^>]+)>)/ig;
  message = message.replace(regexRemoveTags, '')
  message = message.replace(/\b(Error:)|(Error)/g, '')
  // console.log("message", message)
  // message = message.replace(/\b(Error:)/g, '')
  return message
}




export const authorizedRequest = async (url: string, params: null | Object = null, method: RequestmMethodsStrings = "POST", cancelToken?: CancelToken) => {
  // const auth = useSelector(state => state.auth);
  const randomId = keyGenerator()
  // const state = store.getState();
  // const { auth } = state
  let token = localStorage.getItem("token")

  // const token = await getAuthToken(randomId, url)
  // console.log("cancelToken",cancelToken)
  let response = request(url, params, method, token, cancelToken).then((res) => {
    return res
  }).catch((error) => {
    // if (axios.isCancel(error)) {
    //     console.log('Request canceled', error.message);
    //     return "axios request cancelled";

    // }
    if (error.response && error.response.data) {
      const regex = /^\b(rest_authentication_)/g;
      if (error.response.status == 403 && error.response.data.code && regex.test(error.response.data.code)) {
        //  console.log("error->response",error.response)
        /**
         * logout
         */
        store.dispatch(logOut(true))
      }
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
      throw new Error(error.message);
    }
  })
  return response;
}
/**
 * apiRequset
 * @param {string} url
 * @param {POST|GET|PUT|DELETE} method
 * @param {object|null} params
 */
export const unauthorizedRequest = async (url: string, params: null | Object = null, method: RequestmMethodsStrings = "POST", token?: string, cancelToken?: CancelToken) => {
  // const auth = useSelector(state => state.auth);
  return await request(url, params, method, token, cancelToken)
}


/**
 * apiRequset
 * @param {string} url
 * @param {POST|GET|PUT|DELETE} method
 * @param {object|null} params
 */
const request = async (url: string, params: null | Object = null, method: RequestmMethodsStrings = "POST", token?: string, cancelToken?: CancelToken) => {
  // const dispatch = useDispatch();
  // let timezone = getTimezoneOffset()
  // console.log("timezone", timezone)
  if ((method == 'GET' || method == 'DELETE') && params != null) {
    // url = withQuery(url, params)
  }
  let options = {
    method: method.toString(),
    data: params,
    url,
    // headers: token ? { 'Authorization': `Bearer ${token}` } : null,
    // cancelToken: cancelToken ? cancelToken : null,
  };
  if (cancelToken) {
    options['cancelToken'] = cancelToken
  }
  // console.log("options", options)
  let response = AxiosInstance(options).then((res) => {
    return res
  }).catch((error) => {
    // console.log("error", error)
    // if (axios.isCancel(error)) {
    //     console.log('Request canceled', error.message);
    //     return "axios request cancelled";

    // }
    throw new Error(handleErrorResponse(error))
  })
  return response;
}

/**
 *
 * @param {Blob} file
 * @param {altText='',caption='',description=''} options
 */
export const uploadFileServer = async (file, options = { altText: '', caption: '', description: '' }) => {
  // info auth

  const randomId = keyGenerator()
  let token = localStorage.getItem("token")
  let _options = {
    altText: '',
    caption: '',
    description: '',
  }

  _options = { ..._options, ...options }


  try {
    let response = await wp.media()
      .setHeaders({
        Authorization: `Bearer ${token}`,
      })
      // Specify a path to the file you want to upload, or a Buffer
      .file(file)
      .create({
        title: file.name,
        alt_text: _options.altText,
        caption: _options.caption,
        description: options.description,
        // auth_token: storee.auth.token,
        // user_id: storee.auth.userData.id,
      })
      .then(function (res) {
        console.log("response", res)
        // Your media is now uploaded: let's associate it with a post
        return res;
      })

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
}


let loop = 0;
let isRefreshing = false;
let subscribers = [];

const subscribeTokenRefresh = (cb) => {
  console.log("refreshToken->subscribeTokenRefresh")
  subscribers.push(cb);
}

const onRrefreshed = (token) => {
  console.log("refreshToken->onRrefreshed", subscribers.length)
  subscribers.map((cb) => cb(token));
}
const fetchRefreshToken = async (token) => {
  const options = {
    method: "POST",
    headers: { 'Authorization': `Bearer ${token}` },
    data: {},
    url: `${config.url.wpJson}/wp/v2/token/refresh`,
  };
  console.log("token->refreshToken", token);
  try {
    const res = await axios(options)
    return res
  } catch (error) {
    if (error.response) {
      const regex = /^\b(rest_authentication_)/g;
      if ((error.response.status == 403 || error.response.status == 401) && error.response.data.code && regex.test(error.response.data.code)) {
        //  console.log("error->response",error.response)
        /**
         * logout
         */
        store.dispatch(logOut(true))
      }
    }
    throw new Error(error)
  }

}

/**
 * handle throw if Unauthorized
 * hook refresh token when expired
 */
//  AxiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (axios.isCancel(error)) {
//       console.log('refreshToken->Request canceled', error.message);
//       return "axios request cancelled";
//     }
//     const originalRequest = error.config;
//     let refresh_token = localStorage.getItem("refreshToken");
//     console.log("refreshToken->loop", loop)
//     console.log("refreshToken->url", originalRequest.url)
//     if (refresh_token && error.response.status === 401 &&  loop < 1) {
//       loop++;
//       if (!isRefreshing) {
//         originalRequest._retry = true;
//         isRefreshing = true;
//         fetchRefreshToken(refresh_token)
//           .then((res) => {
//             isRefreshing = false;
//             if (res.status === 200 && res.data) {
//               console.log("refreshToken->jwt token d refreshed!");
//               originalRequest.headers.Authorization = `Bearer ${res.data.token}`;
//               onRrefreshed(res.data.token);
//               // return axios(newConfig);


//               const data = res.data
//               localStorage.setItem("token", res.data.token);
//               localStorage.setItem("refreshToken", res.data.refresh_token);
//               // store.dispatch(loginSuccess(res.data)).then((res) => {
//               //   actions.updateUserData();
//               // })
//               subscribers = [];
//             }
//           })
//       }
//       console.log("refreshToken->add", originalRequest.url)
//       return new Promise((resolve) => {
//         subscribeTokenRefresh((token) => {
//           originalRequest.headers.Authorization = `Bearer ${token}`;
//           resolve(axios(originalRequest));
//         });
//       });
//     }
//     return Promise.reject(handleErrorResponse(error));
//   }
// );
